import { CompressionSubSamplingEnum } from '../../space-wall/shared/enums/compression-sub-sampling.enum';
import { LockedPointCoords } from '../../space-wall/shared/interfaces/locked-point-coords.interface';
import { SpaceWallConstants } from '../../space-wall/space-wall.constants';
import { WallSharedConstants } from '../../wall-shared.constants';
import { FunctionType } from '../enums/function-type.enum';
import { IMonitorSettings } from '../interfaces/imonitor-settings.interface';


export class WallMonitor implements IMonitorSettings {
  public MonitorHandler: string;
  public MonitorGroupId: number;
  public WallIndex?: number;
  public DisplayText: string;
  public ScreenName: string;
  public MonitorIndex?: number;

  // for video walls
  public Width: number = WallSharedConstants.DEFAULT_WALL_RESOLUTION_W;
  public Height: number = WallSharedConstants.DEFAULT_WALL_RESOLUTION_H;
  public Angle: number = WallSharedConstants.DEFAULT_MONITOR_ANGLE;
  public TopPosition: number = WallSharedConstants.DEFAULT_MONITOR_TOP;
  public LeftPosition: number = WallSharedConstants.DEFAULT_MONITOR_WIDTH;

  // osbase
  public FunctionType: FunctionType = WallSharedConstants.DEFAULT_MONITOR_TYPE;
  public IsRotated = false;
  public GroupId: number;
  public IdMappingValue: string;

  // walls reticulum
  public Row: number;
  public Column: number;
  public MonitorRef: any;

  public ClientIP: string;
  public IsActive = true;

  public ArtisticOwnSize?: {
    Width: number;
    Height: number;
  };

  public CompressionSubSampling: CompressionSubSamplingEnum;
  public Contrast: number;
  public Brightness: number;
  public CompressionQuality: number;
  public LockedCoordinates: LockedPointCoords = null;

  constructor(values: any = {}) {
    Object.assign(this, values);

    this.DisplayText = this.DisplayText;
    this.CompressionSubSampling = WallMonitor.isNumber(this.CompressionSubSampling)
      ? this.CompressionSubSampling
      : CompressionSubSamplingEnum.YUV420;
    this.Contrast = WallMonitor.isNumber(this.Contrast) ? this.Contrast : SpaceWallConstants.DEFAULT_MONITOR_CONTRAST;
    this.Brightness = WallMonitor.isNumber(this.Brightness) ? this.Brightness : SpaceWallConstants.DEFAULT_MONITOR_BRIGHTNESS;
    this.CompressionQuality = WallMonitor.isNumber(this.CompressionQuality)
      ? this.CompressionQuality
      : SpaceWallConstants.DEFAULT_MONITOR_COMPRESSION_QUALITY;
    this.Width = this.Width && this.Width >= 0 ? this.Width : WallSharedConstants.DEFAULT_WALL_RESOLUTION_W;
    this.Height = this.Height && this.Height >= 0 ? this.Height : WallSharedConstants.DEFAULT_WALL_RESOLUTION_H;
    this.Angle = this.Angle || WallSharedConstants.DEFAULT_MONITOR_ANGLE;
    this.TopPosition = this.TopPosition || 0;
    this.LeftPosition = this.LeftPosition || 0;
  }

  private static isNumber(value: number | null): boolean {
    return typeof value === 'number';
  }
}
